import React, { useMemo, useState } from 'react'
import { Badge, RecordList } from '../BusinessDetailReport/BusinessDetailReport'
import styles from '../BusinessDetailReport/BusinessDetailReport.module.scss'
import { buildCriminalRecords } from './criminalRecordsModel'

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`

export default function CriminalRecords({ records, owner, showSummary = true }) {
    const model = useMemo(() => buildCriminalRecords(records, owner), [records, owner])
    const [showTraffic, setShowTraffic] = useState(false)
    const { summary, serious, traffic } = model

    if (!model.cases.length) return <div className={styles.calmLine}>No criminal records found.</div>

    return (
        <div className={styles.uccList}>
            {showSummary && (
                <div className={styles.inlineBadges}>
                    {summary.felonies > 0 && (
                        <Badge tone={summary.recentFelonies ? 'declined' : 'watch'} dot={summary.recentFelonies > 0}>
                            {plural(summary.felonies, 'felony', 'felonies')}{summary.felonyLatest ? ` (latest ${summary.felonyLatest})` : ''}
                        </Badge>
                    )}
                    {summary.misdemeanors > 0 && (
                        <Badge tone='neutral'>
                            {plural(summary.misdemeanors, 'misdemeanor')}{summary.misdemeanorLatest ? ` (latest ${summary.misdemeanorLatest})` : ''}
                        </Badge>
                    )}
                    {summary.other > 0 && <Badge tone='neutral'>{plural(summary.other, 'other offense')}</Badge>}
                    {summary.traffic > 0 && <Badge tone='neutral'>{summary.traffic} traffic or infraction</Badge>}
                    {summary.warnings > 0 && <Badge tone='declined' dot>{plural(summary.warnings, 'active warning')}</Badge>}
                </div>
            )}
            <div className={styles.note}>
                Lexis matches criminal records by name. Open a case to see whether its date of birth and SSN match the owner.
            </div>

            {serious.length > 0 && <RecordList items={serious} />}

            {traffic.length > 0 && (
                <>
                    <div className={styles.listActions}>
                        <button type='button' className={styles.textButton} onClick={() => setShowTraffic(v => !v)} aria-expanded={showTraffic}>
                            {showTraffic ? 'Hide traffic and infraction records' : `Show ${plural(traffic.length, 'traffic or infraction record')}`}
                        </button>
                    </div>
                    {showTraffic && <RecordList items={traffic} />}
                </>
            )}
        </div>
    )
}
